import Lib from '../../../commons/lib';

export default class Service {
  static penzugyUrl = window.location.origin + '/api/penzugykozos/';

  static cegadatUrl = window.location.origin + '/api/cegadat/';

  // FIZMOD START

  static listFizetesimod(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'fizmod/list',
      args: { requestType: 'fizmod-list' }
    }], fnDone);
  }

  static addFizetesimod(fizmodObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.penzugyUrl + 'fizmod',
      args: { requestType: 'fizmod-post' },
      data: fizmodObject,
    }], fnDone);
  }

  static editFizetesimod(fizmodObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.penzugyUrl + 'fizmod',
      args: { requestType: 'fizmod-put' },
      data: fizmodObject,
    }], fnDone);
  }

  static getFizetesimod(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'fizmod',
      args: { requestType: 'fizmod-get' },
      params: { id: id }
    }], fnDone);
  }

  static deleteFizetesimod(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.penzugyUrl + 'fizmod',
      args: { requestType: 'fizmod-delete' },
      params: { id: id }
    }], fnDone);
  }

  // FIZMOD END

  // PÉNZNEM START

  static listPenznem(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'penznem/list',
      args: { requestType: 'penznem-list' }
    }], fnDone);
  }

  static addPenznem(penznemObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.penzugyUrl + 'penznem',
      args: { requestType: 'penznem-post' },
      data: penznemObject
    }], fnDone);
  }

  static editPenznem(penznemObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.penzugyUrl + 'penznem',
      args: { requestType: 'penznem-put' },
      data: penznemObject,
    }], fnDone);
  }

  static getPenznem(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'penznem',
      args: { requestType: 'penznem-get' },
      params: { id: id }
    }], fnDone);
  }

  static deletePenznem(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.penzugyUrl + 'penznem',
      args: { requestType: 'penznem-delete' },
      params: { id: id }
    }], fnDone);
  }

  // PÉNZNEM END

  // INFLÁCIÓ START

  static listInflacio(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'inflacio/list',
      args: { requestType: 'inflacio-list' }
    }], fnDone);
  }

  static addInflacio(inflacioObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.penzugyUrl + 'inflacio',
      args: { requestType: 'inflacio-post' },
      data: inflacioObject
    }], fnDone);
  }

  static editInflacio(inflacioObject, id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.penzugyUrl + 'inflacio',
      args: { requestType: 'inflacio-put' },
      data: inflacioObject,
      params: { id: id }
    }], fnDone);
  }

  static getInflacio(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'inflacio',
      args: { requestType: 'inflacio-get' },
      params: { id: id }
    }], fnDone);
  }

  static deleteInflacio(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.penzugyUrl + 'inflacio',
      args: { requestType: 'inflacio-delete' },
      params: { id: id }
    }], fnDone);
  }

  // INFLÁCIÓ END

  // BANKTÍPUS START

  static listBankttipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'banktipus/list',
      args: { requestType: 'banktipus-list' }
    }], fnDone);
  }

  static addBanktipus(banktipusObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.penzugyUrl + 'banktipus',
      args: { requestType: 'banktipus-post' },
      data: banktipusObject
    }], fnDone);
  }

  static editBanktipus(banktipusObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.penzugyUrl + 'banktipus',
      args: { requestType: 'banktipus-put' },
      data: banktipusObject,
    }], fnDone);
  }

  static getBanktipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'banktipus',
      args: { requestType: 'banktipus-get' },
      params: { id: id }
    }], fnDone);
  }

  static deleteBanktipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.penzugyUrl + 'banktipus',
      args: { requestType: 'banktipus-delete' },
      params: { id: id }
    }], fnDone);
  }

  // BANKTÍPUS END

  // BANKSZÁMLA START

  static listBankszamla(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'bankszamlapenztar/list',
      args: { requestType: 'bankszamlapenztar-list' },
      params: { tipus: 'BANK' }
    }], fnDone);
  }

  static addBankszamla(bankszamlaObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'bankszamlapenztar-post' },
      data: bankszamlaObject,
    }], fnDone);
  }

  static deleteBankszamla(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'bankszamlapenztar-delete' },
      params: { id: id }
    }], fnDone);
  }

  static editBankszamla(bean, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'bankszamlapenztar-put' },
      data: bean,
    }], fnDone);
  }

  static getBankszamla(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'bankszamlapenztar-get' },
      params: { id: id }
    }], fnDone);
  }

  static viewBankszamla(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'bankszamlapenztar/view',
      args: { requestType: 'bankszamlapenztar-view' },
      params: { id: id }
    }], fnDone);
  }

  static listAktivPenznem(id, only, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'penznem/aktiv',
      args: { requestType: 'penznem-aktiv' },
      params: { id: id, only: only }
    }], fnDone);
  }

  static listAktivCegadat(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.cegadatUrl + 'search',
      params: {
        aktiv: true,
        resultclass: '30'
      },
      data: [id]
    }], fnDone);
  }

  static existsNew(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.cegadatUrl + 'cegadat/existsnew',
      args: { requestType: 'cegadat-existsnew' },
      params: {
        id: id,
        datum: null
      }
    }], fnDone);
  }

  // BANKSZÁMLA END

  // PÉNZTÁR START

  static listHaziPenztar(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'bankszamlapenztar/list',
      args: { requestType: 'hazi-penztar-list' },
      params: { tipus: 'HAZI' },
    }], fnDone);
  }

  static getHaziPenztar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'hazi-penztar-get' },
      params: { id: id },
    }], fnDone);
  }

  static addHaziPenztar(hazipenztarobj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'hazi-penztar-post' },
      data: hazipenztarobj,
    }], fnDone);
  }

  static editHaziPenztar(bean, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'hazi-penztar-put' },
      data: bean,
    }], fnDone);
  }

  static deleteHaziPenztar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.penzugyUrl + 'bankszamlapenztar',
      args: { requestType: 'hazi-penztar-delete' },
      params: { id: id },
    }], fnDone);
  }

  static listHaziPenztarPenztar(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'bankszamlapenztar/listhazipenztarpenztar',
      args: { requestType: 'hazi-penztar-penztar-list' },
      params: { tipus: 'HAZI' },
    }], fnDone);
  }
}
